import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = checking, null = signed out

  const check = useCallback(async () => {
    // CRITICAL: skip when returning from OAuth callback; AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) return;
    try {
      const r = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(r.data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const signOut = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch {}
    setUser(null);
  };

  return <Ctx.Provider value={{ user, setUser, signIn, signOut }}>{children}</Ctx.Provider>;
};

export const useCustomerAuth = () => useContext(Ctx);
